import _ from 'lodash';


export const getAuthBiomeInfo = (state) => _.get(state, 'auth.info.biome', {});

export const getAuthServiceInfo = (state) => _.get(state, 'auth.info.auth', {});
